import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingForSystemsComponent } from './landing-for-systems.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '@app/core/core.module';
import { HeroModule } from '@app/core/components/hero/hero.module';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { SystemIconModule } from '@app/transactions/components/transaction-form/system-icon/system-icon.module';
import { LandingSystemImgModule } from './components/landing-system-img/landing-system-img.module';
import { GradientSystemModule } from './components/gradient-system/gradient-system.module';
import { SystemActivityCardModule } from './components/system-activity-card/system-activity-card.module';
import { BlogBySystemModule } from './components/blog-by-system/blog-by-system.module';
import { SystemsAlternativesModule } from './components/systems-alternatives/systems-alternatives.module';
import { PublicDealsModule } from '@app/landing-page/components/public-deals/public-deals.module';
import { ResumeSystemModule } from './components/resume-system/resume-system.module';
import { PaymentQueueModule } from './components/payment-queue/payment-queue.module';
import { MarketTrendModule } from './components/market-trend/market-trend.module';
import { MapSystemActivityModule } from './components/system-activity-card/map-system-activity/map-system-activity.module';
import { EmptyComponentModule } from './components/empty-component/empty-component.module';
import { NetworksSystemModule } from './components/networks-system/networks-system.module';

const routes: Routes = [
    {
        path: '',
        component: LandingForSystemsComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LandingForSystemsRoutingModule {}

@NgModule({
    declarations: [LandingForSystemsComponent],
    exports: [LandingForSystemsComponent],
    imports: [
        CommonModule,
        LandingForSystemsRoutingModule,
        CoreModule,
        EmptyComponentModule,
        RouterModule,
        HeroModule,
        MarketTrendModule,
        MapSystemActivityModule,
        InfoBlockModule,
        LandingSystemImgModule,
        PaymentQueueModule,
        SystemsAlternativesModule,
        GradientSystemModule,
        ResumeSystemModule,
        SystemActivityCardModule,
        BlogBySystemModule,
        GradientSystemModule,
        MatCardModule,
        PublicDealsModule,
        SystemIconModule,
        NetworksSystemModule
    ]
})
export class LandingForSystemsModule {}
